export enum MeasureType {
    INFO = "INFO",
    LENGTH = "LENGTH",
    ANGLE = "ANGLE",
    AREA = "AREA"
}
